<div class="popover-arrow arrow"></div>
@if (title) {
  <h3 class="popover-title popover-header">{{ title }}</h3>
}
<div class="popover-content popover-body">
  <ng-content></ng-content>
</div>
